import { Component, Input, OnInit } from '@angular/core';
import { UiService } from 'src/app/admin/service/ui.service';
import { ProductService } from 'src/app/market-place/services/product.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit {
  @Input() productId = undefined;

  public comments = [];
  public commentData = '';
  public respondComment = '';
  public commentId = undefined;
  public name = undefined;

  constructor(
    private productSv: ProductService,
    private uiSv: UiService
  ) { }

  ngOnInit() {
    this.getComments();
  }

  async getComments(){
    const res: any = await this.productSv.getComments(this.productId);
    this.comments = res.data;
  }

  async ask(){
    try{
      await this.uiSv.presentLoader();
      const body = {
        comment: this.respondComment || this.commentData,
        productId: this.productId,
        parentId: this.commentId || null
      }
      const res: any = await this.productSv.postComments(body);
      if(res.data.parent_id){
        const comment = this.comments.find(item => item.id === res.data.parent_id);
        comment.child.unshift(res.data);
        this.selectComment(null)
      }else{
        this.comments.unshift(res.data);
        this.commentData = '';
      }
      await this.uiSv.loading.dismiss();
    }catch(err){
      console.error(err);
    }
  } 

  selectComment(ev){
    this.commentId = ev?.id;
    this.name = ev?.name;
    this.respondComment = '';
  }
}
